import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { OrderProposalService } from "../../../services/api/order-proposal.service";
import { OrderProposalActions } from "../../actions/order-proposal.actions";

@Injectable()
export class AcceptProposalEffects {
	accept = createEffect(() =>
		this.actions.pipe(
			ofType(OrderProposalActions.acceptProposal.accept),
			switchMap((action) => {
				return this.orderProposalService.acceptProposal(_.omit(action, "type")).pipe(
					map(() =>
						OrderProposalActions.acceptProposal.acceptSuccess({
							orderProposalId: action.orderProposalId
						})
					),
					catchError((error) =>
						of(OrderProposalActions.acceptProposal.acceptFail({ error }))
					)
				);
			})
		)
	);

	constructor(
		private actions: Actions,
		private orderProposalService: OrderProposalService
	) {}
}
